<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;">
                <template v-if="!(typeof(actionData.messageboxlist_add) != 'undefined'&&!actionData.messageboxlist_add)">
                    <el-button size="medium" type="primary" icon="el-icon-plus" @click="addMessageBoxFun(1)">添加</el-button>
                </template>
                <span v-else style="color: #f9fafc;">空</span>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="670"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="弹窗ID">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.Id" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="弹窗名称" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.Title" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Title || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="弹窗类型">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.DialogsType" placeholder="请选择弹窗类型" style="width: 100%;">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in MESSAGE_TYPE.MESSAGEEBOXTYPE" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.DialogsTypeStr || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="弹窗状态">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.Status" placeholder="请选择弹窗状态" style="width: 100%;">
                            <el-option :value="0" label="未启用"></el-option>
                            <el-option :value="1" label="启用"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.StatusStr || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="站点">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.SiteType" placeholder="请选择站点" style="width: 100%;">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in MESSAGE_TYPE.SITE" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.SiteStr || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="提醒频率">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.Period" placeholder="请选择提醒频率" style="width: 100%;">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in MESSAGE_TYPE.FREQUENCY" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.RemindFrequency || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="创建时间">
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.CreateTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CreateTimeStr || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="280" fixed="right">
                <template slot-scope="scope">
                    <template v-if="!(typeof(actionData.messageboxlist_edit) != 'undefined'&&!actionData.messageboxlist_edit)">
                        <el-button v-if="!scope.row.Status" size="mini" @click="addMessageBoxFun(2, scope.row)">编辑</el-button>
                    </template>
                    <template v-if="!(typeof(actionData.messageboxlist_upanddown) != 'undefined'&&!actionData.messageboxlist_upanddown)">
                        <el-button v-if="scope.row.IsMaxSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownMove(scope.row.Id, -1)">上移</el-button>
                        <el-button v-if="scope.row.IsMinSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownMove(scope.row.Id, 1)">下移</el-button>
                    </template>
                    <template v-if="!(typeof(actionData.messageboxlist_start) != 'undefined'&&!actionData.messageboxlist_start)">
                        <el-button v-if="!scope.row.Status" size="mini" type="primary" @click="clickIsPublish(scope.row.Id, 1)">启用</el-button>
                    </template>
                    <template v-if="!(typeof(actionData.messageboxlist_disable) != 'undefined'&&!actionData.messageboxlist_disable)">
                        <el-button v-if="scope.row.Status" size="mini" type="warning" @click="clickIsPublish(scope.row.Id, 2)">禁用</el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageIndex"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <AddMessageBox ref="messageBox" @onSubmitRefresh="onSubmit"/>
    </div>
</template>

<script>
import { MESSAGE_TYPE } from '@/config/const/common.js'
import AddMessageBox from './index/addMessageBox'
import {
    messageBoxList,         //弹窗列表
    updateProductDomainSortNo, //上移下移
    updateDialogsConfigStatus, //启用禁用
} from "@/service/message";
import { 
  getActionData
} from '@/utils/store'
  export default {
    components: {
        AddMessageBox
    },
    data() {
        return {
            actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
            MESSAGE_TYPE,
            listLoading: false,
            form: {
                PageIndex: 1,
                PageSize: 10,

                Id: '',     //弹窗ID,
                Title: '',      //弹窗名称
                DialogsType:'',    //弹窗类型 1 通用类型，2 活动类型
                Status: '',     // 弹窗状态 1 启用, 0 未启用,-1 未选择
                SiteType: '',   // 站点类型: 1 app, 2 pc, 3 wx ,
                Period: '',     //提醒频率 1 仅首次登陆，2 每天，3 每周，4 每半月，5 每月, 6 仅弹一次
                CreateTime: [], //创建时间

            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数

            
            tableData:[],
        }
    },
    activated(){
        this.handleSearch()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageIndex = val
            this.searchData.PageIndex = val
            this.GetMessageBoxList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageIndex = 1
            this.form.PageSize = val
            this.searchData.PageIndex = 1
            this.searchData.PageSize = val
            this.GetMessageBoxList()
        },
        async GetMessageBoxList(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.Id && delete data.Id
            !data.Title && delete data.Title
            !data.DialogsType && delete data.DialogsType
            if(data.Status === ''){
                data.Status = -1
            }
            !data.SiteType && delete data.SiteType
            !data.Period && delete data.Period
            if(data.CreateTime && data.CreateTime.length) {
                data.CreateStartTime = data.CreateTime[0]
                data.CreateEndTime = data.CreateTime[1]
            }
            delete data.CreateTime
            data.platform = 'pcweb'

            let res = await messageBoxList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.List
            this.total = res.Data.TotalRows
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        //启用禁用
        clickIsPublish(id,is){
            let data = {
                Id: id,
                IsEnable: is==1?true:false,
                platform: "pcweb"
            }
            updateDialogsConfigStatus(data).then((res)=>{
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success(res.Message)
                this.GetMessageBoxList()
            })
        },
        // 点击添加
        addMessageBoxFun(is,rows) {
            if(is == 1) {
                this.$refs.messageBox.open();
            }else{
                this.$refs.messageBox.open(rows);
            }
        },
        //上移下移
        upDownMove: function (id, move) {
            var data = {
                Id: id,
                Difference: move,
                platform: 'pcweb'
            }
            updateProductDomainSortNo(data).then(res => {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('操作成功！')
                this.GetMessageBoxList()
            })
        },
        onSubmit() {
            this.handleSearch()
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
</style>